module.exports = __webpack_public_path__ + "img/cellular.014870a4.svg";